<template>
    <div class="card" :class="cardClasses">
        <span v-if="hasTopSlot" class="card__top">
            <slot name="top"></slot>
        </span>

        <div class="card__text">
            <slot></slot>
        </div>

        <div v-if="link.url" class="card__bottom">
            <div class="card__bottom__button">
                <a
                    :href="link.url"
                    class="card__bottom__button__content"
                    :class="{ 'stretched-link': stretched }"
                >
                    {{ link.text }}
                    <span
                        class="icon-angle-right card__bottom__button__content__icon"
                    ></span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'blue'
        },
        background: {
            type: String,
            default: null
        },
        stretched: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        noButton: {
            type: Boolean,
            default: false
        },
        activated: {
            type: Boolean,
            default: false
        },
        link: {
            type: Object,
            default() {
                return null;
            }
        }
    },

    computed: {
        cardClasses() {
            const classes = [];

            if (this.filled) {
                classes.push('card-filled');
            } else {
                classes.push('card-basic');
            }

            if (this.small) {
                classes.push('card--small');
            }

            if (this.activated) {
                classes.push('card--activated');
            }

            classes.push(`card--${this.color}`);
            return classes;
        },

        hasTopSlot() {
            return !!this.$slots['top'];
        },

        hasDefaultSlot() {
            return !!this.$slots.default;
        }
    }
};
</script>

<style lang="scss" scoped>
.card {
    display: flex;
    flex-direction: column;
}

.card__bottom {
    position: static;
}

.card__top {
    background-color: $brand-blue;
    padding: 5px;
    font-size: 0.85rem;
    color: $brand-white;
    align-self: self-start;
}
</style>
